import { render, staticRenderFns } from "./loading_page.vue?vue&type=template&id=0222bd90&scoped=true"
var script = {}
import style0 from "./loading_page.vue?vue&type=style&index=0&id=0222bd90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0222bd90",
  null
  
)

export default component.exports